import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const useStyles = buildUseStyles('DefaultValueLever', (theme) => ({
  lever: {
    display: 'flex',
    flex: 1,
    '& > div': {
      justifyContent: 'space-between',
      flex: 1,
    },
    '& .FD-MuiFormControl-root': {
      // TODO: investigate this, seems like min-width of 200 is causing alignment issues for picklist inputs
      width: '204px', // fixes alignment of widths between inputs and picklist inputs
    },
    '&& div.FD-MuiInputBase-root': { // the border of the input field
      height: theme.spacing(4), // make inputs thinner
    },
    '&& input.FD-MuiInputBase-input.FD-MuiAutocomplete-input': {
      marginTop: theme.spacing(-1), // Fix picklist text alignment
    },
    '&&& input': {
      color: theme.palette.facet.oceana500, // change color of input text
      fontWeight: 500, // bold
    },
  },
}));

const DefaultValueLever = ({
  disabled, onBlur,
}) => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();

  // workaround for onInlineSubmit not working
  const handleKeyCapture = React.useCallback((e) => {
    // see every keydown below this subtree
    if (e.key === 'Enter' || e.keyCode === 13) {
      onBlur();
    }
  }, [onBlur]);

  return (
    <div className={classes.lever} onKeyDownCapture={handleKeyCapture}>
      <FDStack direction={'column'}>
        <MetaControlField attr={'value'} onBlur={onBlur} disabled={disabled} onChange={resource.metaField('value').attr('type') === 'bool' ? onBlur : undefined} />
        <MetaControlField attr={'originalValue'} />
      </FDStack>
    </div>
  );
};

DefaultValueLever.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export default DefaultValueLever;
